import React from 'react'
import BrandIcon from '../images/icon-brand-recognition.svg'
import DetailedIcon from '../images/icon-detailed-records.svg'
import CustIcon from '../images/icon-fully-customizable.svg'

function Services() {
  return (
    <div className="container  py-16 bg-gray-100">
        <h1 className='font-extrabold text-4xl text-center'>Advance Statics</h1>
        <p className='py-4 text-center'>Tracks how your links are performing across the web with <br /> our advaced statics dashboards</p>
        <div className="flex flex-col sm:flex-row justify-center px-4 sm:px-16 pb-12 mt-8 text-center sm:text-justify">
            <div className="flex-1 shadow px-2 sm:px-8 mx-0 sm:mx-4">
                <img src={BrandIcon} alt="" className='-translate-y-1/2 bg-darkVoilet rounded-full p-2' />
                <h2 className='font-extrabold py-2'>Brand Recognition</h2>
                <p className='pb-4 text-x'>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit error eius, dicta sint sed provident possimus quos iusto ipsam quaerat esse est, culpa veniam rerum ut aspernatur beatae tenetur cupiditate.</p>
            </div>
            <div className="flex-1 bg-gray-300 shadow px-2 sm:px-8 mx-0 sm:mx-4 translate-y-9">
                <img src={DetailedIcon} alt="" className='-translate-y-1/2 bg-darkVoilet rounded-full p-2 ml-4'/>
                <h2 className='font-extrabold py-2'>Detailed Records</h2>
                <p className='pb-4'>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit error eius, dicta sint sed provident possimus quos iusto ipsam quaerat esse est, culpa veniam rerum ut aspernatur beatae tenetur cupiditate.</p>
            </div>
            <div className="flex-1 bg-gray-300 shadow px-2 sm:px-8 mx-0 sm:mx-4 translate-y-1/3 my-0 mb-4 sm:my-4">
                <img src={CustIcon} alt="" className='-translate-y-1/2 bg-darkVoilet rounded-full p-2 ml-4' />
                <h2 className='font-extrabold py-2'>Fully Customizable</h2>
                <p className='pb-4'>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit error eius, dicta sint sed provident possimus quos iusto ipsam quaerat esse est, culpa veniam rerum ut aspernatur beatae tenetur cupiditate.</p>
            </div>
        </div>
    </div>
  )
}

export default Services;